<script setup lang="ts">
defineProps({
    mainHeadlineConfig: {
        type: Object,
        required: false,
        default: () => ({}),
        validator: (rawValue) => {
            return typeof rawValue?.title === 'string'
        }
    }
})
</script>

<template>
    <h1 class="main-headline" v-html="mainHeadlineConfig?.title" />
</template>

<style  lang="scss">
.main-headline {
    @include main-headline;
}
</style>
